import { useStaticQuery, graphql } from "gatsby"

export const useThemeOptions = () => {
  const data = useStaticQuery(graphql`
    query {
      file(name: { eq: "placeholder" }) {
        publicURL
      }
      allWildChildOptions {
        nodes {
          addSiteMap
          businessName
          contact {
            phone
            email
            address {
              city
              state
              street
              zip
            }
          }
          createUsers
          createTags
          createPosts
          createPages
          createCustomPostTypes
          createColorPallete
          createCategories
          cssVarPrefix
          googleMapsLink
          id
          htmlLang
          paginationPrefix
          shouldShowBreakpoints
          pathPrefix
          siteDescription
          siteTitle
          siteUrl
          smoothScroll
          socialFollowLinks {
            name
            url
          }
          usePageTransitions
          useTransitionModal
          useWpRedirects
          withApollo
          wordPressUrl
          widgetAreas {
            sidebarWidgets
          }
        }
      }
    }
  `)

  return {
    ...data.allWildChildOptions.nodes[0],
    placeholderImage: data?.file?.publicURL ? data.file.publicURL : null,
  }
}
